import React from 'react';
import { Grid } from '@material-ui/core';
import { Box, Carousel } from '../../types-hack';
interface IProps {
  images: string[];
}

const ImageCarousel: React.FC<IProps> = ({ images }: IProps) => {
  return (
    <Box p={5} style={{ height: '100%' }}>
      <Carousel navButtonsAlwaysVisible>
        {images.map(imageUrl => {
          return (
            <Grid container direction="row" justify="space-between">
              <Grid item>
                <img height={250} alt="Pendant not available" src={imageUrl} />;
              </Grid>
            </Grid>
          );
        })}
      </Carousel>
    </Box>
  );
};

export default ImageCarousel;
